export enum LinkType {
    SoleTrader = 'SOLE_TRADER',
    LegalPerson = 'LEGAL_PERSON',
    NaturalPerson = 'NATURAL_PERSON',
}

export function getLocalizedLinkType(): Record<LinkType, string> {
    return {
        'SOLE_TRADER': $localize`:@@linkType.soleTrader:Eenmanszaak`,
        'LEGAL_PERSON': $localize`:@@linkType.legalPerson:Vennootschap`,
        'NATURAL_PERSON': $localize`:@@linkType.naturalPerson:Natuurlijk persoon`,
    };
}
